<form class="card mt-2">
  <div class="card-body">
      <h2 class="mb-3">My Assets</h2>
    <i *ngIf="loadingMyEquipments" class="material-icons rotate text-muted">loop</i>
    <p-table [value]="equipments" [responsive]="true" [paginator]="true" [rows]="20" [totalRecords]="equipments?.length || 0" [lazy]="false"
   >
        <ng-template pTemplate="header">
            <tr>
                <th width="150px"></th>
                <th width="8%" [pSortableColumn]="'type'">Type <p-sortIcon [field]="'type'"></p-sortIcon></th>
                <th>Category</th>
                <th>Description</th>
                <th [pSortableColumn]="'dateAssigned'">Assigned Date <p-sortIcon [field]="'dateAssigned'"></p-sortIcon></th>
                <th [pSortableColumn]="'returnDate'">Return Date <p-sortIcon [field]="'returnDate'"></p-sortIcon></th>
                <th [pSortableColumn]="'assignSigned'">Assign Signed <p-sortIcon [field]="'assignSigned'"></p-sortIcon></th>
                <th [pSortableColumn]="'serialNumber'">Serial <p-sortIcon [field]="'serialNumber'"></p-sortIcon></th>
                <th [pSortableColumn]="'barcode'">Barcode <p-sortIcon [field]="'barcode'"></p-sortIcon></th>
                <th>Location</th>
                <th>Status</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-equipment>
            <tr >
                <td>
                  <button class="btn btn-secondary mr-2" (click)="viewAssignedDocument(equipment)" title="View Assign Document">
                    <i class="fas fa-file-download"></i>
                  </button>
                  <button class="btn btn-secondary mr-2" *ngIf="equipment.returnDocumentToSignID" (click)="viewReturnedDocument(equipment)" title="View Return Document">
                    <i class="fas fa-file-upload"></i>
                  </button>
                  <button class="btn btn-secondary mr-2" *ngIf="equipment.assignDocumentToSignID && !equipment.assignSigned" (click)="signAssignement(equipment)" title="Sign">
                    <i class="fas fa-file-signature"></i>
                  </button>
                </td>
                <td>
                    <span class="ui-column-title">Type</span>
                    {{equipment.equipment.type}}</td>
                <td>
                    <span class="ui-column-title">Category</span>
                    {{equipment.assetCategory || '-'}}</td>
                <td>
                    <span class="ui-column-title">Description</span>
                    {{equipment.description || '-'}}</td>

                <td>
                  <span class="ui-column-title">Assigned Date</span>
                  {{equipment.dateAssigned | date:'shortDate' }}</td>
                <td>
                    <span class="ui-column-title">Return Date</span>
                    {{equipment.returnDate | date:'shortDate' }}</td>
                <td>
                    <span class="ui-column-title">Assign Signed</span>
                    {{getAssignSignedDisplay(equipment) }}</td>
                <td>
                    <span class="ui-column-title">Serial</span>
                  {{equipment.equipment.serialNumber || '-' }}</td>
                <td>
                    <span class="ui-column-title">Barcode</span>
                  {{equipment.barcode || '-' }}</td>
                <td>
                    <span class="ui-column-title">Location</span>
                  {{equipment.inventoryAssetLocation || '-' }}</td>
                <td>
                    <span class="ui-column-title">Status</span>
                  {{equipment.assetStatus || '-' }}</td>
            </tr>
        </ng-template>
    </p-table>
  </div>
</form>
